const dynamicPackage = {
  detailedPlan: "詳細計画", // translated
  minimum: "最小", // translated
  maximum: "最大", // translated
};


export default dynamicPackage;
